import { api } from "../config";
import axios from "axios";
import { useStore } from "../hooks/useStore";
import store from "../redux/store";

const blogApi = axios.create({
  baseURL: "https://companyapp.co.uk/",
  headers: {
    "Content-Type": "application/json",
  },
});

export const getOnlineNode = (_endpoint, alt) => {
  const system = store.getState().systemReducer;
  const userData = useStore();
  const accessToken = store.getState().tokenReducer?.access_token;

  let url = `https://${system.subdomain}.companyapp.net` + "/" + _endpoint;
  if (alt) {
    url = _endpoint;
  }

  let params = {
    method: "get",
    url: url,
    headers: {
      "Cache-Control": "no-cache",
    },
    withCredentials: true,
  };

  if (userData && userData.csrf_token) {
    params.headers["X-CSRF-Token"] = userData.csrf_token;
  }

  if (accessToken) {
    params.headers["Authorization"] = `Bearer ${accessToken}`;
  }

  return api(params);
};

export const getExternal = (_endpoint, _method) => {
  const system = store.getState().systemReducer;
  const accessToken = store.getState().tokenReducer?.access_token;
  const method = _method ? _method : "get";
  return blogApi({
    method: method,
    url: `https://${system.subdomain}.companyapp.net` + "/" + _endpoint,
    withCredentials: true,
  });
};

export const getFile = (_endpoint) => {
  const system = store.getState().systemReducer;
  return api({
    method: "get",
    url: `https://${system.subdomain}.companyapp.net` + "/" + _endpoint,
    responseType: "arraybuffer",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getConfig = () => {
  return axios({
    method: "get",
    url: "https://addinconfig.companyapp.net/data.php?version=configv2",
    withCredentials: false,
  });
};

export const getEmail = (data) => {
  return axios({
    method: "get",
    url: "https://addinconfig.companyapp.net/email.php",
    params: data,
    withCredentials: false,
  });
};
